<template>
  <!-- Start Footer -->
  <footer class="footer">
    <div class="container">
      <div class="row footer-cards gy-5">
        <div class="col-lg-5 col-md-6 col-12">
          <div class="footer-logo">
            <router-link to="/" class="foot-logo-img">
      <img v-if="logoSrc" :src="logoSrc" @error="onImgError" alt="" />
            </router-link>
            <p class="footer-info">
              {{ footerContent }}
            </p>
          </div>
        </div>

        <div class="col-lg-4 col-md-4 col-6">
          <div class="foot-content">
            <h3 class="footer-head"> {{ $t('footer.mainLinks') }} </h3>
            <ul class="footer-links row">
              <div class="col-lg-6">
                
                <router-link to="/" class="link"> {{ $t('footer.home') }} </router-link>
                <router-link to="/depatments" class="link"> {{ $t('footer.cats') }} </router-link>
                <router-link to="/uploadAds" class="link" @click="preventLogin()"> {{ $t('footer.upload') }} </router-link>
                <router-link to="/contactView" class="link"> {{ $t('footer.contact') }} </router-link>
                <router-link to="/conditionsView" class="link"> {{ $t('footer.terms') }} </router-link>
              </div>
              <div class="col-lg-6">
                <router-link to="/editProfileView" class="link" @click="preventLogin()"> {{ $t('nav.profile') }} </router-link>
                <router-link to="/favView" class="link" @click="preventLogin()"> {{ $t('nav.favs') }} </router-link>
              </div>
            </ul>
          </div>
        </div>

        <div class="col-lg-3 col-md-2 col-6">
          <div class="foot-content">
            <h3 class="footer-head"> {{ $t('footer.followUs') }} </h3>
            <ul class="footer-links">
              <a v-for="social in uniqueSocials" :key="social.__key" :href="social.link" class="link"> {{ social.name }} </a>
              <!-- <a href="#" class="link"> {{ $t('footer.insta') }} </a>
              <a href="#" class="link"> {{ $t('footer.twitter') }} </a>
              <a href="#" class="link">  {{ $t('footer.youtube') }}</a>
              <a href="#" class="link">  {{ $t('footer.snap') }}</a> -->
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <!-- End Footer -->

  <!-- Start Copy Right -->
  <div class="copy-right">
    <div class="container">
      <div class="row">
        <div class="col-md-10 mx-auto">
          <div class="copy">
            <span>
              {{ designedByText }} 
            </span>
            <span> {{ propertyRightsText }} </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Copy Right -->
</template>

<script>

import axios from 'axios'

export default {
  data() {
    return {
      logo: "",
      nav_and_footer_data : {},
      socials : [],
      assetBase: process.env.VUE_APP_ASSETS_BASE_URL || ""
    };
  },
  computed: {
    logoSrc(){
      const logo = this.nav_and_footer_data?.logo;
      if (logo) return this.resolveAsset(logo);
      return this.logo;
    },
    designedByText(){
      const raw = (this.nav_and_footer_data?.designed_by || '').trim();
      return this.sanitizeBrand(raw);
    }
    ,
    footerContent(){
      const raw = (this.nav_and_footer_data?.content_in_footer || '').trim();
      return this.sanitizeBrand(raw);
    }
    ,
    propertyRightsText(){
      const raw = (this.nav_and_footer_data?.property_rights || '').trim();
      return this.sanitizeBrand(raw);
    },
    uniqueSocials(){
      const list = Array.isArray(this.socials) ? this.socials : [];
      const seen = new Set();
      const out = [];
      for (const s of list){
        const name = String((s?.name || '')).trim().toLowerCase();
        const link = String((s?.link || '')).trim().toLowerCase();
        const id   = String(s?.id ?? '').trim();
        const key = `${id}|${name}|${link}`;
        if (name === '' && link === '') continue;
        if (seen.has(key)) continue;
        seen.add(key);
        out.push({ ...s, __key: key });
      }
      return out;
    }
  },
  methods:{
    sanitizeBrand(text){
      const t = (text || '').trim();
      if (!t) return '';
      // Normalize and remove diacritics safely using Unicode property escapes
      const normalized = t
        .normalize('NFKD')
        .replace(/\p{Diacritic}/gu, '')
        .replace(/\u0640/gu, ''); // remove tatweel
      const pattern = /اوامر الشبكه|اوامر الشبكة|أوامر الشبكة|أوامر الشبكه/i;
      return pattern.test(normalized) ? '' : t;
    },
    resolveAsset(path){
      const base = (this.assetBase || '').replace(/\/+$/,'');
      if (!path) return this.logo;
      const p = typeof path === 'string' ? path.trim() : String(path);
      if (/^(https?:|data:|blob:)/i.test(p) || p.startsWith('/dashboard')) return p;
      const rel = p.startsWith('/') ? p.slice(1) : p;
      const adjusted = rel.startsWith('images/') ? `storage/${rel}` : rel;
      return base ? `${base}/${adjusted}` : p;
    },
    onImgError(e){
      e.target.src = this.logo;
    },
    async getHomeLogo(){
      try {
        const res = await axios.get('home', { headers: { 'X-No-Auth-Redirect': true } });
        this.nav_and_footer_data = res?.data?.data?.nav_and_footer_data || {};
        this.socials = (this.nav_and_footer_data?.socials) ? this.nav_and_footer_data.socials : [];
      } catch (err) {
        this.socials = [];
      }
    },
    preventLogin(){
      const token = sessionStorage.getItem('token');
      if (!token) {
          this.$swal({
              icon: 'error',
              title: 'قم بتسجيل الدخول بحسابك أولاً',
              timer: 3000,
              showConfirmButton: false,

          });
      }
    },
  },
  mounted(){
    this.getHomeLogo()
  }
};
</script>

<style scoped>
a:after {
  
  text-decoration: none;
  color: #262626;
}
</style>
